import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import trialApi, { TrialVerifyEmailRequest } from '../apis/trial.api'
import routes from '../routes/routes'
import Button from '../components/Button'
import Heading from '../components/Heading'
import Page from '../components/Page'

interface MatchParams {
  token: string
}

interface Props extends RouteComponentProps<MatchParams> {}

interface State {
  emailVerified: boolean
}

class EmailVerify extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      emailVerified: false
    }
    this.handleReturnClick = this.handleReturnClick.bind(this)
  }

  handleReturnClick () {
    this.props.history.push(routes.signIn)
  }

  verifyEmail () {
    const { token } = this.props.match.params
    const payload: TrialVerifyEmailRequest = { }
    if (token) payload.token = token
    trialApi.verifyEmail(payload, response => {
      if (response && response.verified) {
        this.setState({ emailVerified: true })
      } else {
        this.props.history.push(routes.signIn)
      }
    })
  }

  componentDidMount () {
    this.verifyEmail()
  }

  render () {
    return this.state.emailVerified &&
      <Page size='full'>
        <Heading text='Email verified!' size="extraLarge" className='mt-40' />
        <p className='mt-4 text-center mb-3 xl:w-2/3'>{i18n("Thank You for requesting a free account of QPRO+. Your email address is verified; you&apos;ll receive an email with sign-in credentials shortly.")}</p>
        <p className='mb-3 text-center'>
          If you have any questions, please contact&nbsp;
          <a className='text-blue-600' href="mailto:hello@quandopro.com">{i18n("hello@quandopro.com")}</a>
        </p>
        <Button
          text={i18n("Return to sign in")}
          onClick={this.handleReturnClick} />
      </Page>
  }
}

export default withRouter(EmailVerify)
